import React, { FC, useEffect, useState } from "react";
import { Stickyheadertitle } from "./PricingTable";
import tooltipNew from "public/tooltip-new.jpg";

interface PricingSubTableArabicProps {
    tableTitle: string;
    tableInternalData: PricingSubTableArabicData[];
    growthPrice?: string;
    scalePrice?: string;
    proPrice?: string;
    tooltip?: any;
}

interface PricingSubTableArabicData {
    title: string;
    subtitle?: string;
    growth: string;
    scale: string;
    pro: string;
    growthTooltip?: string;
    scaleTooltip?: string;
    proTooltip?: string;
    tooltip?: any;
}

const PricingSubTableArabic: FC<PricingSubTableArabicProps> = ({ tableTitle, tableInternalData, growthPrice, scalePrice, proPrice }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (window.innerWidth < 500) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, []);

    return (
        <>
            <div className=" bg-gray-200 mb-5 rounded-md">
                <div className="pricing-table">
                    {tableInternalData.map((data, i) => {
                        return (
                            <>
                                {i === 0 && isMobile ? (
                                    <>
                                        <div className="pricing-table-title table-title-sub sticky top-0" style={{ zIndex: 1 }}>
                                            <p className=" pt-5 font-bold bg-white text-lg">{tableTitle}</p>
                                        </div>
                                        <Stickyheadertitle plan={"النمو"} amount={growthPrice} />
                                        <Stickyheadertitle plan={"الحجم"} amount={scalePrice} />
                                        <Stickyheadertitle plan={"الاحترافي"} amount={proPrice} />
                                    </>
                                ) : null}
                                {i === 0 && !isMobile ? (
                                    <div className="pricing-table-title table-title-sub sticky md:static top-0">
                                        <p className=" pt-5 font-bold bg-white text-right text-lg">{tableTitle}</p>
                                    </div>
                                ) : null}
                                <div className="text-base table-title-sub text-center font-normal text-gray-700 pl-7 flex flex-row w-full" style={{ zIndex: 1 }}>
                                    <div className="flex-1 pt-3 flex justify-center items-center">
                                        {data.pro.split(".").pop() === "png" ? (
                                            <img
                                                src={`pricing-${data.pro}`}
                                                alt={`${data.pro === "yes.png" ? "Green tick" : data.pro === "no.png" ? "Red cross mark" : ""}`}
                                                className="your-image-class"
                                            />
                                        ) : (
                                            <p>{data.pro}</p>
                                        )}
                                    </div>
                                </div>

                                <div className={`text-sm font-normal text-center text-gray-700  flex justify-center items-center ${i === 0 && "no-gap-pricing"}`}>
                                    {data.growth.split(".").pop() === "png" ? (
                                        <img
                                            src={`pricing-${data.growth}`}
                                            alt={`${data.growth === "yes.png" ? "Green tick" : data.growth === "no.png" ? "Red cross mark" : ""}`}
                                        />
                                    ) : data.growth === "Basic" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.growth}</p>
                                            {data.growthTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.growthTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.growth === "Advanced" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.growth}</p>
                                            {data.growthTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.growthTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.growth === "Intermediate" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.growth}</p>
                                            {data.growthTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.growthTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="flex flex-row">{data.growth}</p>
                                    )}
                                </div>
                                <div className={`text-sm font-normal text-center text-gray-700 flex justify-center items-center ${i === 0 && "no-gap-pricing"}`}>
                                    {data.scale.split(".").pop() === "png" ? (
                                        <img src={`pricing-${data.scale}`} alt={`${data.scale === "yes.png" ? "Green tick" : data.scale === "no.png" ? "Red cross mark" : ""}`} />
                                    ) : data.scale === "Basic" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.scale}</p>
                                            {data.scaleTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.scaleTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.scale === "Advanced" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.scale}</p>
                                            {data.scaleTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.scaleTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.scale === "Intermediate" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.scale}</p>
                                            {data.scaleTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.scaleTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="flex flex-row">{data.scale}</p>
                                    )}
                                </div>
                                <div className={`text-sm font-normal text-center text-gray-700  flex justify-center items-center ${i === 0 && "no-gap-pricing"}`}>
                                    {data.tooltip && (
                                        <div className="relative mr-auto pl-2 pt-3 ">
                                            <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5 text-right">
                                                <img src={tooltipNew} alt="info icon" className="pricing-tooltip-icon-new" />
                                                <div className={"pricing-tooltip-content-new"} style={{ zIndex: 3 }}>
                                                    {data.tooltip}
                                                </div>
                                            </span>
                                        </div>
                                    )}
                                    {data.title.split(".").pop() === "png" ? (
                                        <img src={`pricing-${data.title}`} alt="" />
                                    ) : data.title === "Basic" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.title}</p>
                                            {data.proTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.proTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.title === "Advanced" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.title}</p>
                                            {data.proTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.proTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : data.title === "Intermediate" ? (
                                        <div className="flex flex-row ">
                                            <p className="flex flex-row">{data.title}</p>
                                            {data.proTooltip && (
                                                <div className="relative ml-auto pl-2 ">
                                                    <span className="relative inline-block flex-shrink-0 ml-1 mt-0.5">
                                                        <img src="https://assets.gallabox.com/gb-home/info-circle-green.svg" alt="info icon" className="pricing-tooltip-icon" />
                                                        <div className={"pricing-tooltip-content"}>{data.proTooltip}</div>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <p className="flex flex-row">{data.title}</p>
                                    )}
                                </div>
                            </>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default PricingSubTableArabic;
